import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** Tailwind-aware class join: a later `px-4` beats an earlier `px-2`. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
